export const create_choice = "/surveys/createNewSurvey/";
export const file_uploads = '/fileUplods';
export const create_user = '/users/createUser';
export const modify_user = '/users/modifyUser';
export const client_mapping = '/clientMapping'
export const client_details = '/clientMapping/clientDetails';
export const add_new_client = '/clientMapping/addNewClient';
export const modify_client = '/clientMapping/modifyClient';
export const manage_roles_and_access = '/clientMapping/manageRolesAndAccess';
export const add_roles = '/clientMapping/manageRolesAndAccess/addRole';
export const modify_role = '/clientMapping/manageRolesAndAccess/ModifyRole';
export const view_role = '/clientMapping/manageRolesAndAccess/ViewRole';
export const clientPermissions = 'v1/admin/users/v2/users/permissions'
export const details = 'v1/casbin/users'
export const cms = '/cms';
export const cms_news = '/cms/news';
export const cms_add_news = '/cms/news/add';
export const cms_edit_news = '/cms/news/edit';
export const cms_view_news = '/cms/news/view';
export const cms_banners = '/cms/banners';
export const cms_add_banner = '/cms/banners/add';
export const cms_edit_banner = '/cms/banners/edit';
export const cms_view_banner = '/cms/banners/view';
export const cms_media = '/cms/media';
export const cms_amiforyou = '/cms/amiforyou';
export const cms_add_amiforyou = '/cms/amiforyou/add';
export const cms_edit_amiforyou = '/cms/amiforyou/edit';
export const cms_view_amiforyou = '/cms/amiforyou/view';
export const cms_app_polling = '/cms/app-polling';
export const cms_add_app_polling = '/cms/app-polling/add';
export const cms_edit_app_polling = '/cms/app-polling/edit';
export const cms_view_app_polling = '/cms/app-polling/view';
export const hospitals = '/hospitals';
export const hospitals_add = '/hospitals/add';
export const hospitals_edit = '/hospitals/edit';
export const hospitals_view = '/hospitals/view';
export const hospital_schemes = '/hospitals/schemes';
export const hospital_facilities = '/hospitals/facilities';
export const hospital_specialities = '/hospitals/specialities';
export const organizations = '/organizations';
export const organizations_add = '/organizations/add';
export const organizations_edit = '/organizations/edit';